/**
 * æµç¨è°ç¨ç±»å
 */
export enum AifCallType {
    /**
     * é»è®¤å¼
     */
    Default = 0,

    /**
     * åæ­¥è°ç¨
     */
    Sync = 1,

    /**
     * å¼æ­¥è°ç¨
     */
    Async = 2
}